<template>
  <MainLayout>
    <ContentPageHeader functionName="店舗移動管理" pageName="店舗移動開始登録">
    </ContentPageHeader>
    
    <div class="store-transfer-register-form">
      <div class="form-section">
        <!-- 出荷登録日 -->
        <FormDateField 
          label="出荷登録日"
          id="shipmentRegistrationDate" 
          v-model="storeTransfer.shipmentRegistrationDate"
          required
        />

        <!-- 移動先店舗 -->
        <FormSelectSearchField 
          label="移動先店舗" 
          id="destinationStore" 
          v-model="storeTransfer.destinationStore"
          :options="storeOptions"
          required
          size="small"
        />
      </div>
    </div>
    
    <template #footer-buttons>
      <div class="footer-buttons">
        <button class="btn btn-primary" @click="registerStoreTransfer">登録</button>
      </div>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import FormSelectSearchField from '@/components/form/FormSelectSearchField.vue'
import FormDateField from '@/components/form/FormDateField.vue'
import { showLoading, hideLoading } from '@/utils/loadingEventBus';
import service from '../../services/service';

export default {
  name: 'StoreTransferRegisterView',
  components: {
    MainLayout,
    ContentPageHeader,
    FormSelectSearchField,
    FormDateField,
  },
  data() {
    return {
      storeTransfer: {
        shipmentRegistrationDate: '',
        destinationStore: '',
      },
      storeOptions: [], // 初期値を空配列
    };
  },
  computed: {
    defaultStoreTransfer() {
      // ユーザーの店舗IDを初期値に設定
      const userStoreId = this.$store.getters['auth/currentUser']?.storeId;
      return {
        shipmentRegistrationDate: '',
        destinationStore: '',
        movingSourceStore: userStoreId ? userStoreId : '',
        itemCount: 0,
        purchaseTotalAmount: 0
      };
    },
  },
  methods: {
    // バリデーションチェック
    validationCheck() {
      // 必須項目のバリデーションチェック
      if (!this.storeTransfer.shipmentRegistrationDate) {
        return '出荷登録日は必須です';
      }
      if (!this.storeTransfer.destinationStore) {
        return '移動先店舗は必須です';
      }
      
      // 出荷登録日が現在日付より過去の場合はエラー
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const shipmentDate = new Date(this.storeTransfer.shipmentRegistrationDate);
      shipmentDate.setHours(0, 0, 0, 0);
      if (shipmentDate < currentDate) {
        return '出荷登録日は現在日付以降を指定してください';
      }
      
      // 移動先店舗が現在のログインユーザーの店舗と同じ場合はエラー
      const userStoreId = this.$store.getters['auth/currentUser']?.storeId;
      if (parseInt(this.storeTransfer.destinationStore) === userStoreId) {
        return '移動先店舗は現在のログイン店舗と異なる店舗を指定してください';
      }

      return null;
    },
    
    async registerStoreTransfer() {
      try {
        showLoading();
        // バリデーションチェック
        const errorMessage = this.validationCheck();
        if (errorMessage != null) {
          alert(errorMessage);
          return;
        }
        
        // 登録確認ダイアログ
        if (!confirm('店舗移動情報を登録します。\nよろしいですか？')) return;

        // リクエスト形式に変換
        const storeTransferRequest = {
          shipmentRegistrationDate: this.storeTransfer.shipmentRegistrationDate,
          destinationStore: this.storeTransfer.destinationStore,
          movingSourceStore: this.defaultStoreTransfer.movingSourceStore,
          itemCount: this.defaultStoreTransfer.itemCount,
          purchaseTotalAmount: this.defaultStoreTransfer.purchaseTotalAmount
        };

        // 入力情報をDBに保存
        const response = await service.registerStoreTransfer(storeTransferRequest);
        
        if (response.data && response.data.isSuccess) {
          // 店舗移動IDをストアに保存
          const storeTransferId = response.data.storeTransferId;
          this.$store.dispatch('storeTransfer/saveStoreTransferId', storeTransferId);
          
          alert('店舗移動開始登録が完了しました。');
          
          // 店舗移動出荷登録画面に遷移
          sessionStorage.setItem('legitimateNavigation', 'StoreTransferShipping');
          this.$router.push({ 
            name: 'StoreTransferShipping',
            query: { id: storeTransferId }
          });
        } else {
          throw new Error(response.data?.message || '店舗移動開始情報の登録中にエラーが発生しました。');
        }
      } catch (error) {
        alert('店舗移動開始情報の登録中にエラーが発生しました。');
        console.error('店舗移動登録エラー:', error);
      } finally {
        hideLoading();
      }
    },
    async loadStoreOptions() {
      try {
        showLoading();
        const response = await service.getStoreList();
        this.storeOptions = response.data.stores.map(store => ({
          value: store.id,
          label: store.storeName
        }));
      } catch (error) {
        console.error('店舗情報の取得に失敗しました:', error);
        alert('店舗情報の取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    }
  },
  mounted() {
    this.loadStoreOptions();
    this.storeTransfer = this.defaultStoreTransfer;
  }
}
</script>

<style scoped>
.store-transfer-register-form {
  display: flex;
  flex-direction: column;
  background-color: var(--gray-light);
}

.form-section {
  background-color: var(--gray-light);
  padding: 0;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 0;
}
</style>
